import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiLinkedin, FiInstagram, FiYoutube } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16 gap-12">
          <div className="max-w-md">
            <div className="flex items-center mb-6">
              <span className="text-2xl font-black tracking-tighter uppercase">
                ANDREA<span className="text-orange-500 italic">ZUCCARINI</span>
              </span>
            </div>
            
            <div className="flex space-x-4">
              {[
                { icon: FiLinkedin, url: "#" },
                { icon: FiInstagram, url: "#" },
                { icon: FiYoutube, url: "#" }
              ].map((social, i) => (
                <a 
                  key={i} 
                  href={social.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center hover:bg-orange-600 transition-all group"
                >
                  <SafeIcon icon={social.icon} className="w-5 h-5 group-hover:scale-110 transition-transform" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-black uppercase text-xs tracking-widest text-orange-500 mb-6 italic">Legale</h4>
            <ul className="space-y-4 text-slate-400 text-sm font-bold">
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-xs font-bold uppercase tracking-widest">
            © 2024 Andrea Zuccarini Consulting.
          </p>
          <div className="flex items-center space-x-2 text-slate-500 text-xs font-bold uppercase">
            <span>Powered by GENIO BIZ</span>
            <div className="w-1 h-1 bg-orange-500 rounded-full"></div>
            <span>Milan, Italy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;